import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { typo } from '../styles/ds';
import AssistantConversation from './AssistantConversation';
import { useAssistant } from './AssistantContext';

// Full-page rendering of the one shared conversation (see AssistantContext.js).
// Thin wrapper only — the message list/input logic lives in
// AssistantConversation, shared verbatim with the compact panel
// (AssistantWidget.js).
const AssistantPage = () => {
  const { setView } = useAssistant();
  const navigate = useNavigate();

  const handleMinimize = () => {
    setView('compact');
    // Return to wherever Expand was clicked from; fall back to the
    // dashboard if there's no history entry to return to (e.g. /assistant
    // was opened directly via bookmark/URL).
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <Box className="crm-assistant-page" sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 96px)', p: 3, boxSizing: 'border-box' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
        <Box>
          <Typography {...typo.pageTitle} mb={0.5}>עוזר חכם</Typography>
          <Typography variant="body2" color="text.secondary">
            שאל שאלות על הזמנות, לקוחות ומלאי, או בקש שינוי סטטוס להזמנה.
          </Typography>
        </Box>
        <Tooltip title="מזער">
          <IconButton onClick={handleMinimize} size="small">
            <CloseFullscreenIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <AssistantConversation variant="full" />
      </Box>
    </Box>
  );
};

export default AssistantPage;
